import Expertise from "@/components/Custom-manufacturing/Expertise";
import Link from "next/link";
import RequestSampleModalBtn from "@/components/Modal/RequestSample";
import HiringCard from "./HiringCard";
import { useState } from "react";
import AbsoluteSkewebar from "@/components/Common/AbsoluteSkewebar";
import { BreadcrumbJsonLd } from "next-seo";
import MetaTags from "@/components/seo/meta-tags";
import ContactUsModalBtn from "@/components/Modal/ContactUs";
import LocationWrapper from "@/components/us-website/LocationWrapper";
import { WHATSAPP_CONTACT_LINK } from "@/utils/Common";

import { S3_BASE_URL } from "@/constastants/Constant";
const Options = [
  {
    id: "1",
    value: "Detailsofcustomchemicalrequirements",
    width: "6",
    label: "Details of custom chemical requirements",
  },
  {
    id: "2",
    value: "quantityneeded",
    width: "6",
    label: "Quantity needed",
  },
  {
    id: "3",
    value: "Tentativerequistiondate",
    width: "6",
    label: "Tentative requisition date",
  },
  {
    id: "4",
    value: "Requisitioncountry",
    width: "6",
    label: "Requisition country",
  },
];

const NameChange = [
  {
    key: "1",
    css: "rounded-[100%] absolute bottom-[-40%] left-0 translate-x-[-70%] translate-y-[50%] fastFadeOut flex items-center justify-center custom-manufacturing-transition",
    header: "Tailored Chemical Solutions",
    description:
      "Discover limitless possibilities with our solutions designed to meet your unique specifications",
  },
  {
    key: "2",
    css: "rounded-[100%] absolute bottom-[50%] left-0 translate-x-[-100%] md:translate-x-[-150%] translate-y-[50%] fastFadeOut  flex items-center justify-center custom-manufacturing-transition",
    header: "Quality Commitment",
    description: "Our unwavering commitment ensures confidence in every batch.",
  },
  {
    key: "3",
    css: " rounded-[100%] absolute top-[0] left-0 translate-x-[-70%] translate-y-[-100%] fastFadeOut  flex items-center justify-center custom-manufacturing-transition",
    header: "Streamlined Project Mastery",
    description: "Experience seamless execution with agile project management.",
  },
  {
    key: "4",
    css: "rounded-[100%] absolute top-[0] right-0 translate-x-[70%] translate-y-[-100%] fastFadeOut flex items-center justify-center custom-manufacturing-transition",
    header: "Cost Efficiency",
    description: "Your data is safeguarded by stringent security protocols.",
  },

  {
    key: "5",
    css: "rounded-[100%] absolute top-[50%] right-0 translate-x-[110%] sm:translate-x-[150%] translate-y-[-50%] fastFadeOut  flex items-center justify-center custom-manufacturing-transition",
    header: " Confidentiality & Trusted Partners",
    description: "Optimize costs without compromising quality.",
  },
  //TODO: USE ONLY LEFT AND RIGHT PROPERTY WITH POSITION TO MAKE IT WORK WITH SAFARI
  {
    key: "6",
    css: " rounded-[100%] absolute bottom-[-40%] right-0 translate-x-[70%] translate-y-[50%] flex items-center justify-center custom-manufacturing-transition end",
    header: "Technology Driven Operations",
    description:
      "Excellence: Leverage cutting-edge technology for real-time visibility",
  },
];
const options = [
  {
    id: "1",
    label: "Chemical Sourcing Inquiry",
  },
  {
    id: "2",
    label: " Custom Manufacturing requirements",
  },
  {
    id: "3",
    label: " Request a Elixir demo",
  },
  {
    id: "4",
    label: "  Interest in joining the team",
  },
  {
    id: "5",
    label: "Interested in other partnership",
  },
];

const CustomSolutions = () => {
  const [index, setIndex] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (index < 5) {
  //       setIndex(index + 1);
  //     } else {
  //       setIndex(0);
  //     }
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, [index]);

  return (
    <LocationWrapper>
      <div className="overflow-hidden">
        <MetaTags
          title="Custom Chemical Manufacturing: Tailored Solutions for Your Unique
          Needs"
          description="Elchemy: Your partner of choice for custom chemical manufacturing. Discover tailored custom manufacturing solutions for your industrial and commercial needs."
          includeAlternateLink={true}
        />
        <BreadcrumbJsonLd
          itemListElements={[
            {
              position: 1,
              name: "Home",
              item: `${process.env.NEXT_PUBLIC_APP_URL}/`,
            },
            {
              position: 2,
              name: "Custom Manufacturing",
              item: `${process.env.NEXT_PUBLIC_APP_URL}/quality-custom-chemical-manufacturing`,
            },
          ]}
        />
        <div>
          <section>
            <div className="w-full bg-slate-200 relative">
              <img
                src={`${S3_BASE_URL}/products/icons/1709290450.webp`}
                className="w-full h-full object-cover"
                style={{ height: "530px" }}
                alt="Custom Manufacturing Background Image "
              />
              <div className="absolute top-0 w-full  h-[530px] flex justify-center items-center z-10 bg-[#00000024] ">
                <p className="absolute top-[6vh] left-4 sm:left-20 ">
                  <Link
                    href={"/"}
                    className=" font-normal text-[14px] text-[#dfdfdf]"
                  >
                    Home
                  </Link>{" "}
                  <span className="px-1 text-white">/</span>{" "}
                  <span className="font-normal text-[14px] text-white ">
                    Custom Manufacturing
                  </span>
                </p>
                <div className="flex flex-col justify-center items-center pt-20">
                  <h1 className="text-[#FFFFFF] mt-[0.8rem]   text-[24px] md:text-[56px] leading-tight w-[85%] md:w-[80%] text-center p-1 px-4 font-mukta font-normal">
                    Welcome to Elchemy's World of Custom Manufacturing
                    Excellence
                  </h1>

                  <div className="pt-6 flex flex-col md:flex md:flex-row  gap-4">
                    <div className="">
                      <ContactUsModalBtn
                        heading={"Request Custom Formulation"}
                        service="2"
                        subHeading={
                          "Fill in the details required to get the sample."
                        }
                        classes={
                          "w-[240px] h-[48px] bg-red font-mukta text-[16px] text-[#fff] rounded-[3px]"
                        }
                      >
                        <div className="">Request Custom Formulation</div>
                      </ContactUsModalBtn>
                    </div>

                    <a
                      href={WHATSAPP_CONTACT_LINK}
                      target="_blank"
                    >
                      <div className="border-2 border-[#fff] px-4 py-[10px] font-mukta text-[16px] text-center  rounded-[3px] bg-white text-red">
                        {" "}
                        {"  Talk To An Expert"}
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="w-full px-[2rem] sm:px-[4.4rem] md:px-[6.75rem] relative my-10 md:my-24">
              <p className="w-full font-mukta text-[1.2rem]">
                At Elchemy, we transcend the ordinary, redefining the landscape
                of custom manufacturing for chemical innovators worldwide. Our
                commitment to enhancing your experience is not just a promise
                it's our passion.
              </p>
            </div>
          </section>
          <div className="px-[2rem] sm:px-[4.4rem] md:px-[6.75rem]">
            <section>
              <HiringCard />
            </section>
            <section>
              <div className="flex pt-8 md:pt-32 text-3xl ">
                <AbsoluteSkewebar text={"Custom Manufacturing Solutions"} />
              </div>

              <div className="flex flex-col md:flex-row w-[100%] mt-6 md:mt-28">
                <div className="flex flex-col gap-8 w-full md:w-[50%] h-full justify-center item-center  ">
                  <div
                    className=" flex flex-col gap-2 font-normal  fastFadeOut"
                    key={index}
                  >
                    <h2 className="text-[1.4rem] md:text-[1.8rem] md:h-[2rem] font-mukta ">
                      {NameChange[index].header}
                    </h2>

                    <p className="w-[100%] h-[2.5rem] md:w-[50%] md:mt-5 text-[14px] fastFadeOut">
                      {NameChange[index].description}
                    </p>
                  </div>
                  <div className="w-full flex justify-around md:justify-start">
                    <ContactUsModalBtn
                      heading={"Request Custom Formulation"}
                      service="2"
                      subHeading={
                        "Fill in the details required to get the sample."
                      }
                      classes={
                        "w-[240px] h-[48px] bg-red  text-[#fff] rounded-[3px]"
                      }
                    >
                      <div className="">Request Custom Formulation</div>
                    </ContactUsModalBtn>
                  </div>
                </div>
                <div className=" flex justify-center items-center relative w-full md:w-[50%] mt-36 sm:mt-44 md:mt-0 ">
                  <div className="relative">
                    {" "}
                    <img
                      src="https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709101030.svg"
                      alt="Custom Manufacturing Solution "
                      className="z-10 h-[9rem] md:h-[14rem]"
                    />
                    {NameChange?.map((items, id) => {
                      return (
                        <>
                          <div className="">
                            <div
                              onClick={() => {
                                setIndex(id);
                              }}
                              onMouseOver={() => {
                                setIndex(id);
                              }}
                              className={`${items?.css} cursor-pointer ${
                                index === id
                                  ? "w-[6rem] h-[6rem] md:w-[10rem] md:h-[10rem] bg-red"
                                  : " w-[5rem] h-[5rem] md:w-[130px] md:h-[130px] bg-[#EF413614]"
                              }`}
                            >
                              <div
                                className={`text-[10px] md:text-[12px] text-center  ${
                                  index === id
                                    ? "text-white w-[9rem] text-[12px] md:text-[16px] fastFadeOut"
                                    : "w-[6rem]"
                                }`}
                              >
                                {items?.header}
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            </section>

            <section className="mt-40">
              <Expertise Options={Options} />
            </section>
          </div>
        </div>
      </div>
    </LocationWrapper>
  );
};

export default CustomSolutions;
